module.exports = __webpack_public_path__ + "static/media/avatar8.fb426500.jpg";